export const SET_PLACEHOLDER = '@dnd/SET_PLACEHOLDER';
